import type { Account, PublicAccount } from '../bff/types';

export function isPublicAccount(account: Account | PublicAccount): account is PublicAccount {
  return !('details' in account);
}
